import React from 'react';
import AgreementFunctional from './Components/agreementFunctional';
import reducer from './reducer';
import sagas from './sagas';
import { withReducer } from '@store/reducerLoader';

const AgreementPage = ({ buttonMode, buttonName }) => {
	return <AgreementFunctional buttonMode={buttonMode} buttonName={buttonName} />;
};

const ReducedScreen = withReducer('agreement', reducer, sagas)(AgreementPage);
export default ReducedScreen;
